import React from "react";
import { useParams, Link } from "react-router-dom";
import { blogPostsDetail } from "../../../data/blogPosts";

const BlogPostDetail = () => {
  const { id } = useParams();
  const post = blogPostsDetail[id];

  if (!post) {
    return (
      <section className="py-8">
        <div className="flex flex-wrap md:px-4">
          <div className="w-full">
            <div className="md:mx-4 text-center">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">
                Blog Post Not Found
              </h2>
              {/* <Link to="/blog" className="text-purple-600 hover:text-purple-800">
                ← Back to Blog
              </Link> */}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-8">
      <div className="flex flex-wrap md:px-4">
        <div className="w-full">
          <div className="md:mx-4">
            {/* <Link to="/blog" className="text-purple-600 hover:text-purple-800 text-sm mb-6 inline-block">
              ← Back to Blog
            </Link> */}

            <h2 className="text-2xl text-gray-800 font-bold mb-2">{post.title}</h2>
            <p className="text-xs text-gray-400 mb-6">{post.date}</p>

            <div className="text-sm text-gray-400 leading-6 space-y-4">
              {post.content.split("\n\n").map((block, index) => {
                if (block.startsWith("## ")) {
                  return (
                    <h3 key={index} className="text-lg text-gray-800 font-bold mt-6 mb-3">
                      {block.replace("## ", "")}
                    </h3>
                  );
                }
                if (block.includes("\n- ")) {
                  const items = block.split("\n").filter(line => line.trim());
                  return (
                    <ul key={index} className="list-disc ml-5 space-y-1">
                      {items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          {item.replace(/^- /, "")}
                        </li>
                      ))}
                    </ul>
                  );
                }
                if (block.match(/^\d+\. /)) {
                  const items = block.split("\n").filter(line => line.trim());
                  return (
                    <ol key={index} className="list-decimal ml-5 space-y-1">
                      {items.map((item, itemIndex) => (
                        <li key={itemIndex}>
                          {item.replace(/^\d+\. /, "")}
                        </li>
                      ))}
                    </ol>
                  );
                }
                if (block.trim() === "") {
                  return null;
                }
                return (
                  <p key={index}>
                    {block}
                  </p>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlogPostDetail;
